// old
import old1 from '../modules/survey/components/customQuestions/age/img/18-29.png';
import old2 from '../modules/survey/components/customQuestions/age/img/30-39.png';
import old3 from '../modules/survey/components/customQuestions/age/img/40-49.png';
import old4 from '../modules/survey/components/customQuestions/age/img/50-59+.png';
import old5 from '../modules/survey/components/header/img/back.svg';
import old6 from '../modules/survey/components/header/img/backDark.svg';
import old7 from '../UI/checkbox/img/check.svg';
import oldMale1 from '../modules/survey/components/customQuestions/age/img/18-29m.png';
import oldMale2 from '../modules/survey/components/customQuestions/age/img/30-39m.png';
import oldMale3 from '../modules/survey/components/customQuestions/age/img/40-49m.png';
import oldMale4 from '../modules/survey/components/customQuestions/age/img/50-59m.png';

// goal
import goal1 from '../modules/survey/images/options/icons/icon-scales.png';
import goal2 from '../modules/survey/images/options/icons/icon-heart.png';
import goal3 from '../modules/survey/images/options/icons/icon-muscle.png';
import goal4 from '../modules/survey/images/options/icons/iconFlex_female.png';
import goal5 from '../modules/survey/images/options/icons/iconRun_female.png';
import goal6 from '../modules/survey/images/options/icons/icon-seeing.png';
import goalMale4 from '../modules/survey/images/options/icons/iconFlex_male.png';
import goalMale5 from '../modules/survey/images/options/icons/iconRun_male.png';

// physical build
import physicalBuild1 from '../modules/survey/images/options/images/physical_build_slim.png';
import physicalBuild2 from '../modules/survey/images/options/images/physical_build_mid.png';
import physicalBuild3 from '../modules/survey/images/options/images/physical_build_heavier.png';
import physicalBuild4 from '../modules/survey/images/options/images/physical_build_overweight.png';
import physicalBuildMale1 from '../modules/survey/images/options/images/physical_build_slim_m.png';
import physicalBuildMale2 from '../modules/survey/images/options/images/physical_build_mid_m.png';
import physicalBuildMale3 from '../modules/survey/images/options/images/physical_build_heavier_m.png';
import physicalBuildMale4 from '../modules/survey/images/options/images/physical_build_overweight_m.png';

// dream body
import dreamBody1 from '../modules/survey/images/options/images/dream_body_thin.png';
import dreamBody2 from '../modules/survey/images/options/images/dream_body_toned.png';
import dreamBody3 from '../modules/survey/images/options/images/dream_body_curvy.png';
import dreamBody4 from '../modules/survey/images/options/images/dream_body_smaller.png';
import dreamBodyMale1 from '../modules/survey/images/options/images/dream_body_thin_m.png';
import dreamBodyMale2 from '../modules/survey/images/options/images/dream_body_toned_m.png';
import dreamBodyMale3 from '../modules/survey/images/options/images/dream_body_curvy_m.png';
import dreamBodyMale4 from '../modules/survey/images/options/images/dream_body_smaller_m.png';

// zones
import zones1 from '../modules/survey/images/options/images/zones_arm_back.png';
import zones2 from '../modules/survey/images/options/images/zones_abs_core.png';
import zones3 from '../modules/survey/images/options/images/zones_legs_glutes.png';
import zonesMale1 from '../modules/survey/images/options/images/zones_male_arm_back.png';
import zonesMale2 from '../modules/survey/images/options/images/zones_male_abs_core.png';
import zonesMale3 from '../modules/survey/images/options/images/zones_male_legs_glutes.png';

// before after
import beforeAfter1 from '../modules/survey/components/customQuestions/beforeAfter/img/before.jpg';
import beforeAfter2 from '../modules/survey/components/customQuestions/beforeAfter/img/after.jpg';
import beforeAfterMale1 from '../modules/survey/components/customQuestions/beforeAfter/img/before-m.png';
import beforeAfterMale2 from '../modules/survey/components/customQuestions/beforeAfter/img/after-m.png';

// current level
import currentLevel1 from '../modules/survey/images/options/icons/icon_smile.png';
import currentLevel2 from '../modules/survey/images/options/icons/smileGlasses.png';
import currentLevel3 from '../modules/survey/images/options/icons/superhero.png';
import currentLevelMale3 from '../modules/survey/images/options/icons/superhero_male.png';

// duration
import duration1 from '../modules/survey/images/options/icons/icon-minimum.png';
import duration2 from '../modules/survey/images/options/icons/icon-normal.png';
import duration3 from '../modules/survey/images/options/icons/icon-maximum.png';
import duration4 from '../modules/survey/images/options/icons/icon-vervdecide.png';

// physicall active
import physicallActive1 from '../modules/survey/images/options/icons/icon_computer.png';
import physicallActive2 from '../modules/survey/images/options/icons/icon_yoga.png';
import physicallActive3 from '../modules/survey/images/options/icons/icon_walking.png';
import physicallActive4 from '../modules/survey/images/options/icons/icon_running.png';
import physicallActiveMale2 from '../modules/survey/images/options/icons/icon-yoga.png';
import physicallActiveMale3 from '../modules/survey/images/options/icons/iconWalk_male.png';

// sleep
import sleep1 from '../modules/survey/images/options/icons/sleep.png';
import sleep2 from '../modules/survey/images/options/icons/bed.png';
import sleep3 from '../modules/survey/images/options/icons/sleep2.png';

// water
import water1 from '../modules/survey/images/options/icons/coffee.png';
import water2 from '../modules/survey/images/options/icons/two.png';
import water3 from '../modules/survey/images/options/icons/ok.png';
import water4 from '../modules/survey/images/options/icons/horns.png';

// diet type
import dietType1 from '../modules/survey/images/options/icons/diet_type_all.png';
import dietType2 from '../modules/survey/images/options/icons/diet_type_vegetarian.png';
import dietType3 from '../modules/survey/images/options/icons/diet_type_vegan.png';
import dietType4 from '../modules/survey/images/options/icons/diet_type_keto.png';

// before after v2
import beforeAfter21 from '../modules/survey/components/customQuestions/beforeAfterV2/img/img1.jpg';
import beforeAfter22 from '../modules/survey/components/customQuestions/beforeAfterV2/img/stars.svg';
import beforeAfter2Male1 from '../modules/survey/components/customQuestions/beforeAfterV2/img/img2.jpg';

// loader
import loader1 from '../modules/survey/components/customQuestions/loader/img/logo.svg';
import loader2 from '../modules/survey/components/customQuestions/loader/img/logoDark.svg';
import loader3 from '../modules/survey/components/customQuestions/loader/img/bubles2.png';
import loader4 from '../modules/survey/components/customQuestions/loader/components/reviewSlider/components/img/stars.svg';
import loader5 from '../modules/survey/components/customQuestions/loader/components/reviewSlider/components/img/stars-4.svg';
import loader6 from '../modules/survey/components/customQuestions/loader/components/reviewSlider/components/img/stars-4-dark.svg';

// fitness_level
import fitnessLevel1 from '../modules/survey/images/options/icons/fitness_level_beginner.png';
import fitnessLevel2 from '../modules/survey/images/options/icons/fitness_level_intermediate.png';
import fitnessLevel3 from '../modules/survey/images/options/icons/fitness_level_advanced.png';

// work_frequency
import workFrequency1 from '../modules/survey/images/options/icons/work_frequency_minimum.png';
import workFrequency2 from '../modules/survey/images/options/icons/work_frequency_normal.png';
import workFrequency3 from '../modules/survey/images/options/icons/work_frequency_maximum.png';
import workFrequency4 from '../modules/survey/images/options/icons/work_frequency_dontKnow.png';

// work_time
import workTime1 from '../modules/survey/images/options/icons/work_time_minimum.png';
import workTime2 from '../modules/survey/images/options/icons/work_time_normal.png';
import workTime3 from '../modules/survey/images/options/icons/work_time_maximum.png';
import workTime4 from '../modules/survey/images/options/icons/work_time_decide.png';

// typical_day
import typicalDay1 from '../modules/survey/images/options/icons/typical_day_office.png';
import typicalDay2 from '../modules/survey/images/options/icons/typical_day_walks.png';
import typicalDay3 from '../modules/survey/images/options/icons/typical_day_physical.png';
import typicalDay4 from '../modules/survey/images/options/icons/typical_day_home.png';

// without
import without1 from '../modules/survey/components/customQuestions/without/img/chart1en.png';

// sleep_v2
import sleepV2_1 from '../modules/survey/images/options/icons/sleep_minimum.png';
import sleepV2_2 from '../modules/survey/images/options/icons/sleep_normal.png';
import sleepV2_3 from '../modules/survey/images/options/icons/sleep_maximum.png';

// job_activity
import jobActivity1 from '../modules/survey/images/options/icons/icon_sedentary.png';

// gender_custom
import genderCustom1 from '../modules/survey/components/customQuestions/genderCustom/img/female.png';
import genderCustom2 from '../modules/survey/components/customQuestions/genderCustom/img/male.png';

// age_v2
import ageV2_1 from '../modules/survey/images/options/images/18-29.png';
import ageV2_2 from '../modules/survey/images/options/images/30-39.png';
import ageV2_3 from '../modules/survey/images/options/images/40-49.png';
import ageV2_4 from '../modules/survey/images/options/images/50-59+.png';
import ageV2_1m from '../modules/survey/images/options/images/18-29m.png';
import ageV2_2m from '../modules/survey/images/options/images/30-39m.png';
import ageV2_3m from '../modules/survey/images/options/images/40-49m.png';
import ageV2_4m from '../modules/survey/images/options/images/50-59m.png';

// body_type_v2
import bodyTypeV2_1 from '../modules/survey/images/options/images/appleBody.png';
import bodyTypeV2_2 from '../modules/survey/images/options/images/pear.png';
import bodyTypeV2_3 from '../modules/survey/images/options/images/square.png';
import bodyTypeV2_4 from '../modules/survey/images/options/images/hourglass.png';
import bodyTypeV2_5 from '../modules/survey/images/options/images/triangle.png';
import bodyTypeV2_6 from '../modules/survey/images/options/images/trapezoid.svg';
import bodyTypeV2_1m from '../modules/survey/images/options/images/appleBodyMale.png';
import bodyTypeV2_2m from '../modules/survey/images/options/images/pearMale.png';
import bodyTypeV2_3m from '../modules/survey/images/options/images/squareMale.png';
import bodyTypeV2_4m from '../modules/survey/images/options/images/trapezoidMale.png';
import bodyTypeV2_5m from '../modules/survey/images/options/images/triangleMale.png';
import bodyTypeV2_6m from '../modules/survey/images/options/images/hourglassMale.png';

// life_event
import lifeEvent1 from '../modules/survey/images/options/icons/icon_vacation.png';
import lifeEvent2 from '../modules/survey/images/options/icons/icon_wedding.png';
import lifeEvent3 from '../modules/survey/images/options/icons/icon_summer.png';
import lifeEvent4 from '../modules/survey/images/options/icons/icon_gathering.png';
import lifeEvent5 from '../modules/survey/images/options/icons/icon_birthday.png';
import lifeEvent6 from '../modules/survey/images/options/icons/icon_not.png';
import lifeEvent7 from '../modules/survey/images/options/icons/icon_other.png';

// info_graphic
import infoGraphic1 from '../modules/survey/components/customQuestions/infoGraphic/img/arrow-down.svg';
import infoGraphic2 from '../modules/survey/components/customQuestions/infoGraphic/img/chart1.svg';
import infoGraphic3 from '../modules/survey/components/customQuestions/infoGraphic/img/chart1Dark.svg';
import infoGraphic4 from '../modules/survey/components/customQuestions/infoGraphic/img/chart2.svg';
import infoGraphic5 from '../modules/survey/components/customQuestions/infoGraphic/img/chart2Dark.svg';
import infoGraphic6 from '../modules/survey/components/customQuestions/infoGraphic/img/chart3.svg';
import infoGraphic7 from '../modules/survey/components/customQuestions/infoGraphic/img/chart3Dark.svg';
import infoGraphic8 from '../modules/survey/components/customQuestions/infoGraphic/img/label-blue.svg';
import infoGraphic9 from '../modules/survey/components/customQuestions/infoGraphic/img/label-green.svg';
import infoGraphic10 from '../modules/survey/components/customQuestions/infoGraphic/img/reviewer-one.jpg';
import infoGraphic11 from '../modules/survey/components/customQuestions/infoGraphic/img/reviewer-three.jpg';
import infoGraphic12 from '../modules/survey/components/customQuestions/infoGraphic/img/reviewer-two.jpg';
import infoGraphic13 from '../modules/survey/components/customQuestions/infoGraphic/img/stars.png';
import infoGraphic14 from '../modules/survey/components/customQuestions/infoGraphic/img/starsTwo.png';


// life_style
import lifeStyle1 from '../modules/survey/images/options/icons/life_style_habits.png';
import lifeStyle2 from '../modules/survey/images/options/icons/life_style_needs.png';

// stay_track
import stayTrack1 from '../modules/survey/images/options/icons/stay_track_immune.png';
import stayTrack2 from '../modules/survey/images/options/icons/stay_track_improving.png';
import stayTrack3 from '../modules/survey/images/options/icons/stay_track_libido.png';
import stayTrack4 from '../modules/survey/images/options/icons/stay_track_looking.png';
import stayTrack5 from '../modules/survey/images/options/icons/stay_track_strength.png';

// life_changes_v2
import lifeChangesV2_1 from '../modules/survey/images/options/icons/cross.png';
import lifeChangesV2_2 from '../modules/survey/images/options/icons/relieved-face.png';
import lifeChangesV2_3 from '../modules/survey/images/options/icons/laugh.png';
import lifeChangesV2_4 from '../modules/survey/images/options/icons/stars-eyes.png';

// info_users_achieve
import infoUsersAchieve1 from '../modules/survey/components/customQuestions/infoUsersAchieve/img/bg_en.png';
import infoUsersAchieve2 from '../modules/survey/components/customQuestions/infoUsersAchieve/img/bg_en_dark.png';

// info_review
import infoReview1 from '../modules/survey/components/customQuestions/infoReview/img/reviewer-one.jpg';
import infoReview2 from '../modules/survey/components/customQuestions/infoReview/img/reviewer-three.jpg';
import infoReview3 from '../modules/survey/components/customQuestions/infoReview/img/reviewer-two.jpg';
import infoReview4 from '../modules/survey/components/customQuestions/infoReview/img/stars.png';
import infoReview5 from '../modules/survey/components/customQuestions/infoReview/img/starsTwo.png';

// ailments
import ailments2 from '../modules/survey/images/options/icons/icon_pill.png';
import ailments3 from '../modules/survey/images/options/icons/icon_asthma.png';
import ailments4 from '../modules/survey/images/options/icons/icon_diseases.png';

// medications_v2
import medicationsV2_1 from '../modules/survey/images/options/icons/icon_sun2.png';
import medicationsV2_2 from '../modules/survey/images/options/icons/icon_test_tube.png';
import medicationsV2_3 from '../modules/survey/images/options/icons/icon_dna.png';
import medicationsV2_4 from '../modules/survey/images/options/icons/icon_alembic.png';

// getting_ready
import gettingReady1 from '../modules/survey/components/customQuestions/gettingReady/img/bg.png';
import gettingReady2 from '../modules/survey/components/customQuestions/gettingReady/img/bgDark.png';
import gettingReady3 from '../modules/survey/components/customQuestions/gettingReady/img/illust1.png';
import gettingReady4 from '../modules/survey/components/customQuestions/gettingReady/img/illust2.png';
import gettingReady5 from '../modules/survey/components/customQuestions/gettingReady/img/illust3.png';

// map_v3
import mapV3 from '../modules/survey/components/customQuestions/mapV3/img/download.png';

// info_famous
import infoFamous1 from '../modules/survey/components/customQuestions/infoFamous/img/logo1.png';
import infoFamous2 from '../modules/survey/components/customQuestions/infoFamous/img/logo1Dark.png';
import infoFamous3 from '../modules/survey/components/customQuestions/infoFamous/img/logo2.png';
import infoFamous4 from '../modules/survey/components/customQuestions/infoFamous/img/workoutsImg_en.png';
import infoFamous5 from '../modules/survey/components/customQuestions/infoFamous/img/workoutsImg_en_blak.png';

// email_permission
import emailPermission from '../modules/survey/components/customQuestions/emailPermission/img/newsletter.png';

// goal bb
import goalBB1 from '../modules/survey/components/customQuestions/goal_bb/img/bg.jpg';
import goalBB2 from '../modules/survey/components/customQuestions/goal_bb/img/bgm.jpg';

// describes bb
import describesBB1 from '../modules/survey/components/customQuestions/describes_bb/img/small.jpg';
import describesBB2 from '../modules/survey/components/customQuestions/describes_bb/img/average.jpg';
import describesBB3 from '../modules/survey/components/customQuestions/describes_bb/img/heavier.jpg';
import describesBB4 from '../modules/survey/components/customQuestions/describes_bb/img/saggy.jpg';
import describesBBMale1 from '../modules/survey/components/customQuestions/describes_bb/img/small_m.jpg';
import describesBBMale2 from '../modules/survey/components/customQuestions/describes_bb/img/average_m.jpg';
import describesBBMale3 from '../modules/survey/components/customQuestions/describes_bb/img/heavier_m.jpg';
import describesBBMale4 from '../modules/survey/components/customQuestions/describes_bb/img/saggy_m.jpg';

// sit bb
import sitBB1 from '../modules/survey/components/customQuestions/sit_bb/img/bg.jpg';
import sitBB2 from '../modules/survey/components/customQuestions/sit_bb/img/bgm.jpg';

// train bb
import trainBB1 from '../modules/survey/components/customQuestions/train_bb/img/bg.jpg';
import trainBB2 from '../modules/survey/components/customQuestions/train_bb/img/bgm.jpg';

// chart
import chart1 from '../modules/survey/components/customQuestions/chart/components/chartBlock/img/chart1.svg';
import chart2 from '../modules/survey/components/customQuestions/chart/components/chartBlock/img/chart2.svg';
import chart3 from '../modules/survey/components/customQuestions/chart/components/chartBlock/img/chart1Dark.svg';

// appInfo
import appInfo1 from '../modules/survey/components/customQuestions/appInfo/img/img_light.jpg';

// ob_physical_build
import obPhysicalBuild1 from '../modules/survey/images/options/images/ob_physical_build_heavier.png';
import obPhysicalBuild2 from '../modules/survey/images/options/images/ob_physical_build_mid.png';
import obPhysicalBuild3 from '../modules/survey/images/options/images/ob_physical_build_overweight.png';
import obPhysicalBuild4 from '../modules/survey/images/options/images/ob_physical_build_slim.png';

// ob_dream_body
import obDreamBody1 from '../modules/survey/images/options/images/ob_dream_body_curvy.png';
import obDreamBody2 from '../modules/survey/images/options/images/ob_dream_body_smaller.png';
import obDreamBody3 from '../modules/survey/images/options/images/ob_dream_body_thin.png';
import obDreamBody4 from '../modules/survey/images/options/images/ob_dream_body_toned.png';

// ob_fitness_exp
import obFitnessExp1 from '../modules/survey/images/questions/describes_experience.webp';

// ob_perf_weight
import obPerfWeight1 from '../modules/survey/images/questions/last_perfect_weight.webp';

// ob_pilates_exp
import obPilatesExp1 from '../modules/survey/images/questions/tried_pilates.webp';

// ob_target_zone
import obTargetZone1 from '../modules/survey/images/questions/target_zone.webp';

// ob_flexible
import obFlexible1 from '../modules/survey/images/questions/flexible.webp';

// ob_stairs 
import obStairs1 from '../modules/survey/images/questions/walking_stairs.webp';

// ob_sleep
import obSleep1 from '../modules/survey/images/questions/long_sleep.webp';

// ob_meals
import obMeals1 from '../modules/survey/images/questions/feel_meals.webp';

// ob_meal_breakfast
import obMealBreakfast1 from '../modules/survey/images/questions/breakfast.webp';

// ob_meal_lunch
import obMealLunch1 from '../modules/survey/images/questions/lunch.webp';

// ob_meal_dinner
import obMealDinner1 from '../modules/survey/images/questions/dinner.webp';


// all image arrays
const oldImageArray = [old1, old2, old3, old4, old5, old6, old7];
const oldImageArrayMale = [oldMale1, oldMale2, oldMale3, oldMale4, old5, old6, old7];
const goalImageArray = [goal1, goal2, goal3, goal4, goal5, goal6];
const goalImageArrayMale = [goal1, goal2, goal3, goalMale4, goalMale5, goal6];
const physicalBuildImageArray = [physicalBuild1, physicalBuild2, physicalBuild3, physicalBuild4];
const physicalBuildImageArrayMale = [physicalBuildMale1, physicalBuildMale2, physicalBuildMale3, physicalBuildMale4];
const dreamBodyImageArray = [dreamBody1, dreamBody2, dreamBody3, dreamBody4];
const dreamBodyImageArrayMale = [dreamBodyMale1, dreamBodyMale2, dreamBodyMale3, dreamBodyMale4];
const zonesImageArray = [zones1, zones2, zones3];
const zonesImageArrayMale = [zonesMale1, zonesMale2, zonesMale3];
const beforeAfterImageArray = [beforeAfter1, beforeAfter2];
const beforeAfterImageArrayMale = [beforeAfterMale1, beforeAfterMale2];
const currentLevelImageArray = [currentLevel1, currentLevel2, currentLevel3];
const currentLevelImageArrayMale = [currentLevel1, currentLevel2, currentLevelMale3];
const durationImageArray = [duration1, duration2, duration3, duration4];
const physicallActiveImageArray = [physicallActive1, physicallActive2, physicallActive3, physicallActive4];
const physicallActiveImageArrayMale = [physicallActive1, physicallActiveMale2, physicallActiveMale3, goalMale5];
const sleepImageArray = [sleep1, sleep2, sleep3, currentLevel3];
const waterImageArray = [water1, water2, water3, water4];
const dietTypeImageArray = [dietType1, dietType2, dietType3, dietType4];
const beforeAfter2ImageArray = [beforeAfter21, beforeAfter22];
const beforeAfter2ImageArrayMale = [beforeAfter2Male1, beforeAfter22];
const loaderImageArray = [loader1, loader2, loader3, loader4, loader5, loader6];
const fitnessLevelArray = [fitnessLevel1, fitnessLevel2, fitnessLevel3];
const workFrequencyArray = [workFrequency1, workFrequency2, workFrequency3, workFrequency4];
const workTimeArray = [workTime1, workTime2, workTime3, workTime4];
const typicalDayArray = [typicalDay1, typicalDay2, typicalDay3, typicalDay4];
const dietTypeV2Array = [dietType1, dietType2, dietType3, dietType4];
const withoutArray = [without1];
const sleepV2Array = [sleepV2_1, sleepV2_2, sleepV2_3];
const waterV2Array = [water1, water2, water3, water4];
const jobActivityArray = [jobActivity1, physicallActive1,  physicallActive3];
const genderCustomArray = [genderCustom1, genderCustom2];
const ageV2Array = [ageV2_1, ageV2_2, ageV2_3, ageV2_4];
const ageV2ArrayMale = [ageV2_1m, ageV2_2m, ageV2_3m, ageV2_4m];
const bodyTypeV2Array = [bodyTypeV2_1, bodyTypeV2_2, bodyTypeV2_3, bodyTypeV2_4, bodyTypeV2_5, bodyTypeV2_6];
const bodyTypeV2ArrayMale = [bodyTypeV2_1m, bodyTypeV2_2m, bodyTypeV2_3m, bodyTypeV2_4m, bodyTypeV2_5m, bodyTypeV2_6m];
const lifeEventArray = [lifeEvent1, lifeEvent2, lifeEvent3, lifeEvent4, lifeEvent5, lifeEvent6, lifeEvent6, lifeEvent7];
const infoGraphicArray = [infoGraphic1, infoGraphic2, infoGraphic3, infoGraphic4, infoGraphic5, infoGraphic6, infoGraphic7, infoGraphic8, infoGraphic9, infoGraphic10, infoGraphic11, infoGraphic12, infoGraphic13, infoGraphic14];
const lifeStyleArray = [lifeStyle1, lifeStyle2];
const stayTrackArray = [stayTrack1, stayTrack2, stayTrack3, stayTrack4, stayTrack5];
const lifeChangesV2Array = [lifeChangesV2_1, lifeChangesV2_2, lifeChangesV2_3, lifeChangesV2_4];
const infoUsersAchieveArray = [infoUsersAchieve1, infoUsersAchieve2];
const infoReviewArray = [infoReview1, infoReview2, infoReview3, infoReview4, infoReview5];
const ailmentsArray = [currentLevel1, ailments2, ailments3, ailments4];
const medicationsV2Array = [medicationsV2_1, medicationsV2_2, medicationsV2_3, medicationsV2_4, currentLevel1];
const gettingReadyArray = [gettingReady1, gettingReady2, gettingReady3, gettingReady4, gettingReady5];
const mapV3Array = [mapV3];
const infoFamousArray = [infoFamous1, infoFamous2, infoFamous3, infoFamous4, infoFamous5];
const emailPermissionArray = [emailPermission];
const goalBBImageArray = [goalBB1, old5, old6, old7];
const goalBBImageArrayMale = [goalBB2, old5, old6, old7];
const describesBBImageArray = [describesBB1, describesBB2, describesBB3, describesBB4];
const describesBBImageArrayMale = [describesBBMale1, describesBBMale2, describesBBMale3, describesBBMale4];
const sitBBImageArray = [sitBB1];
const sitBBImageArrayMale = [sitBB2];
const trainBBImageArray = [trainBB1];
const trainBBImageArrayMale = [trainBB2];
const chartArray = [chart1, chart2, chart3];
const appInfoArray = [appInfo1];
const obPhysicalBuildArray = [obPhysicalBuild1, obPhysicalBuild2, obPhysicalBuild3, obPhysicalBuild4];
const obDreamBodyArray = [obDreamBody1, obDreamBody2, obDreamBody3, obDreamBody4];
const obFitnessExpArray = [obFitnessExp1];
const obPerfWeightArray = [obPerfWeight1];
const obPilatesExpArray = [obPilatesExp1];
const obTargetZoneArray = [obTargetZone1];
const obFlexibleArray = [obFlexible1];
const obStairsArray = [obStairs1];
const obSleepArray = [obSleep1];
const obMealsArray = [obMeals1];
const obMealBreakfastArray = [obMealBreakfast1];
const obMealLunchArray = [obMealLunch1];
const obMealDinnerArray = [obMealDinner1];

// imageDownloader
export default function (nextStep, gender) {
	const imageDownloaderContainer = document.getElementById('imageDownloader');
    // console.log(nextStep);
    // console.log(gender);

	function createImagesSrc(arr) {
		arr.forEach(link => {
			const img = document.createElement('img');
			img.src = link;
			imageDownloaderContainer.appendChild(img);
		});
	}

    function clearImagesSrc() {
        imageDownloaderContainer.innerHTML = '';
    }

	if (nextStep === 'age') {

		if (gender === 'male') {
			createImagesSrc(oldImageArrayMale);
		} else {
			createImagesSrc(oldImageArray);
		}

	}

	if (nextStep === 'goal_female_auto') {

        if (gender === 'male') {
            createImagesSrc(goalImageArrayMale);
		} else {
            createImagesSrc(goalImageArray);
		}

	}

	if (nextStep === 'physical_build') {

        if (gender === 'male') {
            createImagesSrc(physicalBuildImageArrayMale);
		} else {
            createImagesSrc(physicalBuildImageArray);
		}

	}

	if (nextStep === 'dream_body') {

        if (gender === 'male') {
            createImagesSrc(dreamBodyImageArrayMale);
		} else {
            createImagesSrc(dreamBodyImageArray);
		}

	}

	if (nextStep === 'zones') {

        if (gender === 'male') {
            createImagesSrc(zonesImageArrayMale);
		} else {
            createImagesSrc(zonesImageArray);
		}

	}

	if (nextStep === 'before_after') {

        if (gender === 'male') {
            createImagesSrc(beforeAfterImageArrayMale);
		} else {
            createImagesSrc(beforeAfterImageArray);
		}

	}

	if (nextStep === 'current_level') {

        if (gender === 'male') {
            createImagesSrc(currentLevelImageArrayMale);
		} else {
            createImagesSrc(currentLevelImageArray);
		}

	}

	if (nextStep === 'duration') {
		createImagesSrc(durationImageArray);
	}

	if (nextStep === 'physicall_active') {

        if (gender === 'male') {
            createImagesSrc(physicallActiveImageArrayMale);
		} else {
            createImagesSrc(physicallActiveImageArray);
		}

	}

	if (nextStep === 'sleep') {
		createImagesSrc(sleepImageArray);
	}

	if (nextStep === 'water') {
		createImagesSrc(waterImageArray);
	}

	if (nextStep === 'diet_type_auto') {
		createImagesSrc(dietTypeImageArray);
	}

	if (nextStep === 'before_after_v2') {

        if (gender === 'male') {
            createImagesSrc(beforeAfter2ImageArrayMale);
		} else {
            createImagesSrc(beforeAfter2ImageArray);
		}

	}

	if (nextStep === 'loader') {
		createImagesSrc(loaderImageArray);
	}

	if (nextStep === 'fitness_level') {
		createImagesSrc(fitnessLevelArray);
	}

	if (nextStep === 'work_frequency') {
		createImagesSrc(workFrequencyArray);
	}

	if (nextStep === 'work_time') {
		createImagesSrc(workTimeArray);
	}

	if (nextStep === 'typical_day') {
		createImagesSrc(typicalDayArray);
	}

	if (nextStep === 'diet_type_v2') {
		createImagesSrc(dietTypeV2Array);
	}

	if (nextStep === 'without') {
		createImagesSrc(withoutArray);
	}

	if (nextStep === 'sleep_v2') {
		createImagesSrc(sleepV2Array);
	}

	if (nextStep === 'water_v2') {
		createImagesSrc(waterV2Array);
	}

	if (nextStep === 'job_activity') {
		createImagesSrc(jobActivityArray);
	}

	if (nextStep === 'gender_custom') {
		createImagesSrc(genderCustomArray);
	}

	if (nextStep === 'gender_custom') {
		createImagesSrc(genderCustomArray);
	}

	if (nextStep === 'age_v2') {
		createImagesSrc(ageV2Array);

		if (gender === 'male') {
				createImagesSrc(ageV2ArrayMale);
		} else {
			createImagesSrc(ageV2Array);
		}
	}

	if (nextStep === 'goal_bb') {

		if (gender === 'male') {
			createImagesSrc(goalBBImageArrayMale);
		} else {
			createImagesSrc(goalBBImageArray);
		}

	}

	if (nextStep === 'body_type_v2') {
		createImagesSrc(bodyTypeV2Array);

		if (gender === 'male') {
				createImagesSrc(bodyTypeV2ArrayMale);
		} else {
			createImagesSrc(bodyTypeV2Array);
		}
	}

	if (nextStep === 'describes_bb') {

        if (gender === 'male') {
            createImagesSrc(describesBBImageArrayMale);
		} else {
            createImagesSrc(describesBBImageArray);
		}

	}

	if (nextStep === 'life_event') {
		createImagesSrc(lifeEventArray);
	}

	if (nextStep === 'info_graphic') {
		createImagesSrc(infoGraphicArray);
	}

	if (nextStep === 'life_style') {
		createImagesSrc(lifeStyleArray);
	}

	if (nextStep === 'stay_track') {
		createImagesSrc(stayTrackArray);
	}

	if (nextStep === 'life_changes_v2') {
		createImagesSrc(lifeChangesV2Array);
	}

	if (nextStep === 'info_users_achieve') {
		createImagesSrc(infoUsersAchieveArray);
	}

	if (nextStep === 'info_review') {
		createImagesSrc(infoReviewArray);
	}

	if (nextStep === 'ailments') {
		createImagesSrc(ailmentsArray);
	}

	if (nextStep === 'medications_v2') {
		createImagesSrc(medicationsV2Array);
	}

	if (nextStep === 'getting_ready') {
		createImagesSrc(gettingReadyArray);
	}

	if (nextStep === 'map_v3') {
		createImagesSrc(mapV3Array);
	}

	if (nextStep === 'info_famous') {
		createImagesSrc(infoFamousArray);
	}

	if (nextStep === 'email_permission') {
		createImagesSrc(emailPermissionArray);
	}

	if (nextStep === 'sit_bb') {

		if (gender === 'male') {
			createImagesSrc(sitBBImageArrayMale);
		} else {
			createImagesSrc(sitBBImageArray);
		}

	}

	if (nextStep === 'train_bb') {

		if (gender === 'male') {
			createImagesSrc(trainBBImageArrayMale);
		} else {
			createImagesSrc(trainBBImageArray);
		}

	}

	if (nextStep === 'chart') {
		createImagesSrc(chartArray);
	}

	if (nextStep === 'ob_social_proof') {
		createImagesSrc(appInfoArray);
	}

	if (nextStep === 'ob_physical_build') {
		createImagesSrc(obPhysicalBuildArray);
	}

	if (nextStep === 'ob_dream_body') {
		createImagesSrc(obDreamBodyArray);
	}

	if (nextStep === 'ob_fitness_exp') {
		createImagesSrc(obFitnessExpArray);
	}

	if (nextStep === 'ob_perf_weight') {
		createImagesSrc(obPerfWeightArray);
	}

	if (nextStep === 'ob_pilates_exp') {
		createImagesSrc(obPilatesExpArray);
	}

	if (nextStep === 'ob_target_zone') {
		createImagesSrc(obTargetZoneArray);
	}

	if (nextStep === 'ob_flexible') {
		createImagesSrc(obFlexibleArray);
	}

	if (nextStep === 'ob_stairs') {
		createImagesSrc(obStairsArray);
	}

	if (nextStep === 'ob_sleep') {
		createImagesSrc(obSleepArray);
	}

	if (nextStep === 'ob_meals') {
		createImagesSrc(obMealsArray);
	}

	if (nextStep === 'ob_meal_breakfast') {
		createImagesSrc(obMealBreakfastArray);
	}

	if (nextStep === 'ob_meal_lunch') {
		createImagesSrc(obMealLunchArray);
	}

	if (nextStep === 'ob_meal_dinner') {
		createImagesSrc(obMealDinnerArray);
	}

	if (nextStep === 'ob_result_feedback') {
		createImagesSrc(infoReviewArray);
	}

	if (nextStep === 'ob_creating_load') {
		createImagesSrc(gettingReadyArray);
	}

	if (nextStep === 'ob_map') {
		createImagesSrc(mapV3Array);
	}

    if (!nextStep) {
		clearImagesSrc();
	}

}
